import { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { setAccessToken, clearAccessToken } from "../lib/authToken";
import { oktaAuth } from "./oktaConfig";
import { getApiBearerToken } from "./oktaTokens";

async function syncTokensFromOkta() {
  const tokens = await oktaAuth.tokenManager.getTokens();
  const apiToken = getApiBearerToken(tokens);
  const accessToken = tokens.accessToken?.accessToken;
  const idToken = tokens.idToken?.idToken;

  if (apiToken) {
    setAccessToken(apiToken);
    localStorage.setItem("accessToken", apiToken);
  }
  if (accessToken) {
    localStorage.setItem("oktaAccessToken", accessToken);
  }
  if (idToken) {
    localStorage.setItem("idToken", idToken);
  }
}

export function TokenSync() {
  const { authState } = useOktaAuth();

  useEffect(() => {
    if (authState?.isAuthenticated) {
      // Refresh Bearer copies from Okta only — do not wipe user/profile keys
      // (that would break deep links opened in a new tab).
      syncTokensFromOkta();
    } else if (authState && !authState.isAuthenticated) {
      clearAccessToken();
    }
  }, [authState]);

  useEffect(() => {
    const onRenewed = () => syncTokensFromOkta();
    oktaAuth.tokenManager.on("renewed", onRenewed);
    oktaAuth.tokenManager.on("added", onRenewed);
    return () => {
      oktaAuth.tokenManager.off("renewed", onRenewed);
      oktaAuth.tokenManager.off("added", onRenewed);
    };
  }, []);

  return null;
}
